import React, { useState } from "react";

/**
 * Result-row avatar for the command palette.
 *   contact → colored initials circle (people are round)
 *   account → company favicon in a rounded square; on load-error (or no
 *             domain) it falls back to a colored initials chip — never a
 *             broken image.
 *
 * The per-entity color is chosen from a fixed palette via a CSS class
 * (`cpAvatar--c{n}`), not an inline style, so the same name is always the
 * same color without hard-coding colors in the markup.
 */
const COLOR_COUNT = 8;

const initialsOf = (name = "") => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const colorIndexOf = (key = "") => {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return hash % COLOR_COUNT;
};

const EntityAvatar = ({ type, name = "", domain = "" }) => {
  const [faviconFailed, setFaviconFailed] = useState(false);
  const useFavicon = type === "account" && domain && !faviconFailed;

  if (useFavicon) {
    return (
      <span className="cpAvatar cpAvatar--account cpAvatar--favicon">
        <img
          src={`https://www.google.com/s2/favicons?domain=${encodeURIComponent(
            domain
          )}&sz=64`}
          alt=""
          loading="lazy"
          onError={() => setFaviconFailed(true)}
        />
      </span>
    );
  }

  const colorIndex = colorIndexOf(domain || name);
  return (
    <span
      className={`cpAvatar cpAvatar--${type} cpAvatar--initials cpAvatar--c${colorIndex}`}
    >
      {initialsOf(name)}
    </span>
  );
};

export default EntityAvatar;
